import { render, staticRenderFns } from "./ComplaintSectorAdd.vue?vue&type=template&id=6e97dd36&"
import script from "./ComplaintSectorAdd.vue?vue&type=script&lang=js&"
export * from "./ComplaintSectorAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports